import { useEffect, useRef } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { setNavigator } from './navigation';
import PaceProgressActions from '../actions/PaceProgressActions';

export default function NavigationBinder() {
    const navigate = useNavigate();
    const location = useLocation();
    const locationRef = useRef(location);

    useEffect(() => {
        locationRef.current = location;
    }, [location]);

    useEffect(() => {
        setNavigator(navigate, () => locationRef.current);
    }, [navigate]);

    useEffect(() => {
        PaceProgressActions.onLocationChange(location.pathname);
    }, [location.pathname]);

    return null;
}
